import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';

import { L10nBase } from '@skylab-shared/core';
import { ToastDelay } from '@skylab-shared/ui';

import { L10n } from '@skylab-angular-shared/core';

import { NgClass } from '@angular/common';
import { FilepickerInsComponent, FileSizeUnit } from '../file-picker/filepicker.component-ins';
import { ImageComponent } from '../image/image.component';
import { ToastService } from '../toast/toast.service';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'skl-imagepicker-ins',
    templateUrl: './imagepicker.component-ins.html',
    imports: [NgClass, TooltipDirective, ImageComponent, FilepickerInsComponent, IconComponent]
})
export class ImagePickerComponentIns {
    @Input() public placeholder: string | null = null;
    @Input() public srcName: string | null = null;
    @Input() public maxSize: number | null = null;
    @Input() public maxDimension: number | null = null;
    @Input() public src: string | null = null;
    @Input() public accept: string | null = 'image/*';

    @Input() public ratio = '5:1';
    @Input() public unit = FileSizeUnit.MB;

    @Output() public onPick = new EventEmitter<File | null>();

    @ViewChild('filepicker', {static: true}) public filepicker!: FilepickerInsComponent;

    public deleteImageTooltip: string;

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
        private readonly toastService: ToastService
    ) {
        this.deleteImageTooltip = l10n._T('ui.image-picker.remove-image');
    }

    public onClearButton(): void {
        this.filepicker.handleClear();
    }

    public pickImage(): void {
        this.filepicker.handlePick();
    }

    public onFileClear(): void {
        this.src = null;
        this.onPick.emit(null);
    }

    public onFilePick(file: File): void {
        const imageSrc = URL.createObjectURL(file);
        let image = new Image();
        image.src = imageSrc;

        image.onload = ev => {
            if (this.maxDimension
                && ((this.maxDimension < image.naturalHeight) || (this.maxDimension < image.naturalWidth))) {
                this.toastService.showAsync({
                    type: 'error',
                    duration: ToastDelay.Short,
                    text: this.l10n._T('ui.image-picker.dimension-error', {fileName: file.name, maxDimension: this.maxDimension})
                });
                this.filepicker.handleClear();
                return;
            }
            this.src = imageSrc;
            this.onPick.emit(file);

            image.onload = null;
        };
    }
}
